export default __webpack_public_path__ + "static/media/step-two.8da1ca8f.png";